// @ts-check

/**
 * @file Slot-aware Link that inherits defaults from WithDefaultStyle.
 */

import {Link as ExpoLink} from "expo-router"
import withDefaultStyleSlot from "@kaspernj/api-maker/build/utils/with-default-style-slot"

const Link = withDefaultStyleSlot(ExpoLink, "Link")

export default Link
